import { IPhoneSchema } from '../../../../../repositories/monolith-python/entities/offer/PhoneSchema';
import { IOfferState } from '../../../../reducers';

export const mapPhones = (offer: IOfferState): Array<IPhoneSchema> | null => {
  const { phones: phonesRaw } = offer;

  if (!Array.isArray(phonesRaw)) {
    return null;
  }

  // Удалить телефоны null - падает Backend
  const phones = phonesRaw.filter(item => !!item && item.number) as Array<IPhoneSchema>;

  return phones;
};
